<template>
  <div class="xianxia">
    <div class="top">
      <h3>
        {{ rowMsg.paper_title }}
        <span v-if="rowMsg.exam_type == 2">(线下考试)</span>
      </h3>
      <p>
        考生姓名：<span style="margin-right: 20px">{{ rowMsg.user_name }}</span
        >考试时间：<span>{{ rowMsg.exam_time }}</span>
      </p>
    </div>
    <table border="1" cellspacing="0" cellpadding="0" width="100%" style="text-align: center; line-height: 40px">
      <tr>
        <th>姓名</th>
        <th>开始时间</th>
        <th>结束时间</th>
        <th>答题用时</th>
        <th>客观题得分</th>
        <th>主观题得分</th>
        <th>总得分</th>
      </tr>
      <tr>
        <td>{{ rowMsg.user_name }}</td>
        <td>{{ msg.start_time || msg.exam_time }}</td>
        <td>{{ msg.end_time || "--" }}</td>
        <td>{{ rowMsg.exam_type == 2 ? "--" : msg.exam_time }}</td>
        <td>{{ kscore || "--" }}</td>
        <td>{{ zscore || "--" }}</td>
        <td>{{ rowMsg.exam_type == 2 ? msg.score : totalscore }}</td>
      </tr>
    </table>
    <div v-if="rowMsg.exam_type != 2" class="card-box">
      <div class="list">
        <div v-for="item in list" :id="item.uuid" class="item">
          <div class="title">{{ item.exam_index }}.{{ item.title }}</div>
          <div class="ans">
            <p v-for="(mi, key) in item.option">{{ key }} {{ mi }}</p>
          </div>
          <div class="msg">
            <div>
              正确答案：<span v-for="mi in item.correct" style="margin-right: 20px">{{ mi }}</span>
              您的答案

              <!-- <span v-for="mi in item.receiver.correct" v-if="item.receiver&&item.receiver.correct">{{ mi||'无' }}</span> -->
              <div v-if="Array.isArray(item.receiver.correct)" class="media-box" style="flex: 1; word-break: break-all">
                <img
                  v-for="(mi, index) in item.imgs"
                  v-if="Array.isArray(item.imgs) && item.imgs.length > 0"
                  width="90%"
                  :src="mi"
                />
                <video
                  v-for="(mi, index) in item.videos"
                  v-if="Array.isArray(item.videos) && item.videos.length > 0"
                  width="90%"
                  :src="mi"
                  controls="controls"
                ></video>
                <span v-if="Array.isArray(item.texts) && item.texts.length > 0" style="max-width: 50%">{{
                  item.receiver.correct.join(",")
                }}</span>
              </div>
            </div>
            <!-- <div>错误人数：888 错误率：29%</div> -->
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            :current-page="page_index"
            :page-sizes="[20, 40, 60, 100]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="answer">
        <div class="name">答题卡<!-- <span>{{ totalscore }}</span> --></div>
        <div class="queslist">
          <span
            v-for="item in statusList"
            :class="[item.status == 1 ? 'right' : item.status == 0 ? 'none' : 'wrong']"
            @click="gotoid(item.uuid)"
          >
            {{ item.index }}</span
          >
        </div>
        <div class="desc">
          <span class="right"></span>正确 <span class="wrong"></span>错误 <span class="none"></span>未做
        </div>
        <div class="pagination">
          <el-pagination
            small
            :current-page="page_index"
            :page-sizes="[20, 40, 60, 100]"
            :page-size="page_size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TotalScore, TotalScoreDetail } from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  props: ["rowMsg"],
  data() {
    return {
      subject: [],
      page_size: 20,
      totalscore: 0,
      statusList: [],
      msg: {},
      zscore: 0,
      kscore: 0,
      list: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    gotoid(id) {
      document.getElementById(id).scrollIntoView();
    },
    getList() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.list = this.subject.slice((this.page_index - 1) * this.page_size, this.page_index * this.page_size);
      this.statusList = this.list.map((item) => {
        const receiver = item.receiver;
        // console.log(receiver)
        if ((receiver && Array.isArray(receiver.correct) && receiver.correct.length == 0) || !receiver.correct) {
          return {
            index: item.exam_index,
            status: 0,
            uuid: item.uuid,
          };
        }
        if (receiver.pass == 0) {
          return {
            index: item.exam_index,
            status: -1,
            uuid: item.uuid,
          };
        } else {
          return {
            index: item.exam_index,
            status: 1,
            uuid: item.uuid,
          };
        }
      });
    },
    init() {
      TotalScoreDetail(this.rowMsg.uuid, {
        page_index: this.page_index,
        page_size: this.page_size,
      }).then((res) => {
        if (res.subject) {
          this.msg = res;
          res.subject.sort((a, b) => {
            return a.exam_index - b.exam_index;
          });
          this.total = res.subject.length;
          const video = ["mp4", "flv"];
          const img = ["png", "jpg", "jpeg"];
          this.subject = res.subject.map((it) => {
            it.imgs = [];
            it.videos = [];
            it.texts = [];
            const list = it.receiver ? it.receiver.correct : "";
            if (list instanceof Array) {
              list.forEach((mi) => {
                const substr = mi.split(".");
                const last = substr[substr.length - 1];
                if (video.indexOf(last.toLowerCase()) >= 0) {
                  it.videos.push(mi);
                } else if (img.indexOf(last.toLowerCase()) >= 0) {
                  it.imgs.push(mi);
                } else {
                  it.texts.push(mi);
                }
              });
            }
            return it;
          });
          // this.list = res.subject
          this.getList();
          let totalscore = 0;
          let zscore = 0;
          let kscore = 0;
          res.subject.map((item) => {
            const receiver = item.receiver;
            if (item.type == 3) {
              zscore += receiver.score || 0;
            } else {
              kscore += receiver.score || 0;
            }
            totalscore += receiver.score || 0;
          });
          this.zscore = zscore;
          this.kscore = kscore;
          this.totalscore = totalscore;
        }
      });
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.top {
  border: 1px solid #eee;
  line-height: 2;
  padding: 15px 10px;
  margin-bottom: 20px;
}
.card-box {
  display: flex;
  .list {
    width: 75%;
    .item {
      border: 1px solid #bbb;
      margin: 20px 0;
      padding: 10px;

      .msg {
        display: flex;
        justify-content: space-between;
      }
      .ans {
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        line-height: 2;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
  .answer {
    width: 25%;
    border: 1px solid #bbb;
    margin: 20px 10px;
    padding: 10px;
    .name {
      display: flex;
      justify-content: space-between;
    }
    .desc {
      border-top: 1px solid #bbb;
      margin-top: 10px;
    }
    .queslist,
    .desc {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      span {
        display: inline-block;
        width: 30px;
        height: 30px;
        margin: 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
      }
      .right {
        background-color: seagreen;
        color: white;
      }
      .wrong {
        background-color: red;
        color: white;
      }
      .none {
        border: 1px solid #bbb;
      }
    }
  }
}
.media-box {
  display: inline-block;
  video,
  img {
    width: 400px;
    max-height: 200px;
  }
}
</style>
